import React, { useEffect, useState, useRef } from 'react';
import { FaTools, FaStar, FaFacebookF, FaPlayCircle, FaChevronLeft, FaChevronRight, FaWhatsapp, FaPlay } from 'react-icons/fa';

function Projects() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const [projects, setProjects] = useState([]);
  const [error, setError] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showFacebookModal, setShowFacebookModal] = useState(false);
  const [showProjectInfoModal, setShowProjectInfoModal] = useState(false);
  const [modalSlideIndex, setModalSlideIndex] = useState(0);
  const projectListRef = useRef(null);

  useEffect(() => {
    fetch('https://www-hzh6.vercel.app/backend/api.php')
      .then(res => {
        if (!res.ok) {
          throw new Error('Load failed');
        }
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.indexOf('application/json') === -1) {
          throw new Error('Response is not JSON');
        }
        return res.json();
      })
      .then(data => {
        setProjects(data);
        if (data.length > 0) {
          setSelectedProject(data[0]);
        }
      })
      .catch(err => {
        console.log('API not available, using mock data:', err.message);
        // Mock data with enhanced structure for gallery
        const mockProjects = [
          {
            id: 1,
            title: 'מסעדת פסטה בסטה - קרית מוצקין',
            desc: 'הקמת מסעדה מלאה מאפס - עבודות שלד, גמר ועיצוב פנים',
            image: 'images/pasta-basta/future/IMG_3619.webp',
            gallery: [
              // תהליך
              'images/pasta-basta/proccess/IMG_3687.webp',
              'images/pasta-basta/proccess/IMG_3827.webp',
              'images/pasta-basta/proccess/IMG_4008.webp',
              'images/pasta-basta/proccess/0469C058-BDA4-451C-B269-DAD736BC9813.webp',
              'images/pasta-basta/proccess/9265E101-7FAB-4D9C-8667-E543299FACFE.webp',
              'images/pasta-basta/proccess/D788F0B6-13E6-4C50-AC16-9AAF33EDDC27.webp',
              'images/pasta-basta/proccess/ec0afb29-04d5-4671-a9dd-7ef111c49cb5.webp',
              // עתידי
              'images/pasta-basta/future/IMG_3619.webp',
              'images/pasta-basta/future/IMG_3608.webp',
              'images/pasta-basta/future/IMG_3250.webp',
              'images/pasta-basta/future/F1505E17-809F-4400-A8F5-B5EC997133BF.webp',
              // סרטונים
              'https://res.cloudinary.com/ddpkjfebv/video/upload/f_auto,vc_h264/v1764971816/IMG_3876_xvkci7.mp4',
              'https://res.cloudinary.com/ddpkjfebv/video/upload/f_auto,vc_h264/v1764971821/IMG_3957_yiemce.mp4'
            ],
            video: null
          },
          {
            id: 2,
            title: 'פנטהאוס רחוב גורדון - נתניה',
            desc: 'שיפוץ מקיף של פנטהאוס יוקרתי - לפני ואחרי',
            image: 'images/gordon-penthouse/after/IMG_0779.webp',
            gallery: [
              // לפני
              'images/gordon-penthouse/before/IMG_5965.webp',
              'images/gordon-penthouse/before/IMG_6001.webp',
              'images/gordon-penthouse/before/IMG_6012.webp',
              'images/gordon-penthouse/before/IMG_6015.webp',
              // אחרי
              'images/gordon-penthouse/after/IMG_0779.webp',
              'images/gordon-penthouse/after/IMG_0941.webp',
              'images/gordon-penthouse/after/IMG_0948.webp',
              'images/gordon-penthouse/after/IMG_1503.webp',
              'images/gordon-penthouse/after/IMG_1592.webp',
              // סרטונים
              'https://res.cloudinary.com/ddpkjfebv/video/upload/f_auto,vc_h264/v1764971830/IMG_0947_iqs1k8.mp4',
              'https://res.cloudinary.com/ddpkjfebv/video/upload/f_auto,vc_h264/v1764971824/IMG_5995_ovmftu.mp4'
            ],
            video: null
          },
          {
            id: 3,
            title: 'חדר הרב - בית הכנסת מקדונלד נתניה',
            desc: 'שיפוץ והקמת חדר רב בבית כנסת',
            image: 'images/harav-netanya/after/IMG_3098.webp',
            gallery: [
              // לפני
              'images/harav-netanya/before/6e53f0af-99bf-417f-af56-c209d129877d.webp',
              'images/harav-netanya/before/e6c41c9a-f692-4715-b2fd-1de56532cc91.webp',
              // אחרי
              'images/harav-netanya/after/0dcd2b02-1198-40e3-9397-3f361fd8fa22.webp',
              'images/harav-netanya/after/46b3b922-ebfe-421b-8ab4-222399440595.webp',
              'images/harav-netanya/after/82bede64-c28c-4e56-8608-f5c9781e04c0.webp',
              'images/harav-netanya/after/IMG_3098.webp',
              'images/harav-netanya/after/f9c80fa0-83e3-4da6-8627-c523bb8b7039.webp',
              // סרטון
              'https://res.cloudinary.com/ddpkjfebv/video/upload/f_auto,vc_h264/v1764971809/2ba98106-7a84-4af4-909c-d6f7715fd1b2_ntumrn.mp4'
            ],
            video: null
          },
          {
            id: 4,
            title: 'כפר תבור - שיפוץ בית פרטי',
            desc: 'שיפוץ מקיף של בית פרטי - מהפך מלא',
            image: 'images/kfar-tavor/after/IMG_2808.webp',
            gallery: [
              // לפני
              'images/kfar-tavor/before/IMG_9721.webp',
              'images/kfar-tavor/before/IMG_9722.webp',
              'images/kfar-tavor/before/IMG_9735.webp',
              'images/kfar-tavor/before/IMG_9741.webp',
              'images/kfar-tavor/before/IMG_9792.webp',
              // אחרי
              'images/kfar-tavor/after/IMG_2808.webp',
              'images/kfar-tavor/after/IMG_2812.webp',
              'images/kfar-tavor/after/IMG_2813.webp',
              'images/kfar-tavor/after/IMG_2820.webp',
              'images/kfar-tavor/after/IMG_2825.webp',
              'images/kfar-tavor/after/IMG_2849.webp',
              // סרטונים
              'https://res.cloudinary.com/ddpkjfebv/video/upload/f_auto,vc_h264/v1764971820/IMG_2826_fs5dbo.mp4',
              'https://res.cloudinary.com/ddpkjfebv/video/upload/f_auto,vc_h264/v1764971822/IMG_2833_zrfjmh.mp4'
            ],
            video: null
          },
          {
            id: 5,
            title: 'מלכת שבא נתניה - מהפך בדירת קבלן',
            desc: 'מהפך מלא בדירת קבלן חדשה - עיצוב ועבודות גמר',
            image: 'images/malkat-shva/after/IMG_2436.webp',
            gallery: [
              // לפני
              'images/malkat-shva/before/IMG_0124.webp',
              'images/malkat-shva/before/IMG_0127.webp',
              'images/malkat-shva/before/IMG_0131.webp',
              'images/malkat-shva/before/IMG_0137.webp',
              // אחרי
              'images/malkat-shva/after/IMG_2436.webp',
              'images/malkat-shva/after/IMG_2437.webp',
              'images/malkat-shva/after/IMG_2441.webp',
              'images/malkat-shva/after/IMG_2443.webp',
              'images/malkat-shva/after/IMG_2477.webp',
              // סרטון
              'https://res.cloudinary.com/ddpkjfebv/video/upload/f_auto,vc_h264/v1764971813/IMG_2479_dcljov.mp4'
            ],
            video: null
          }
        ];
        setProjects(mockProjects);
        setSelectedProject(mockProjects[0]);
      });
  }, []);

  // Handle project selection
  const handleProjectSelect = (project) => {
    setSelectedProject(project);
    setCurrentImageIndex(0);
    setModalSlideIndex(0);
  };

  // Handle thumbnail click
  const handleThumbnailClick = (index) => {
    setCurrentImageIndex(index);
  };

  const publicBase = process.env.PUBLIC_URL || '';

  // Build a safe media src respecting PUBLIC_URL (supports sub-path deploys and Hebrew names)
  const getMediaSrc = (media) => {
    if (!media) return media;
    if (media.startsWith('http')) return media;
    const withBase = media.startsWith('/') ? `${publicBase}${media}` : `${publicBase}/${media}`;
    try {
      return encodeURI(withBase);
    } catch (e) {
      return withBase;
    }
  };

  // Get current media (image or video)
  const getCurrentMedia = () => {
    if (!selectedProject) return null;
    const hasGallery = Array.isArray(selectedProject.gallery) && selectedProject.gallery.length > 0;
    const media = hasGallery
      ? selectedProject.gallery[currentImageIndex % selectedProject.gallery.length]
      : selectedProject.image;
    return media; // Return raw media string for YouTube check
  };

  // Get media source (for non-YouTube media)
  const getCurrentMediaSrc = () => {
    const media = getCurrentMedia();
    if (!media || media.startsWith('youtube:')) return null;
    return getMediaSrc(media);
  };

  // Check if current media is YouTube
  const isCurrentMediaYouTube = () => {
    const media = getCurrentMedia();
    return media && media.startsWith('youtube:');
  };

  // Get YouTube video ID
  const getYouTubeId = () => {
    const media = getCurrentMedia();
    if (media && media.startsWith('youtube:')) {
      return media.replace('youtube:', '');
    }
    return null;
  };

  // Check if current media is video
  const isCurrentMediaVideo = () => {
    const media = getCurrentMedia();
    return media && (media.includes('.mp4') || media.includes('.webm') || media.includes('.ogg') || media.includes('.MP4'));
  };

  // Get tag for project
  const getTag = (project) => {
    if (project.id === 1) return 'בתהליך';
    if (project.id === 2) return 'פופולרי';
    if (project.id === 4) return 'מיוחד';
    return null;
  };

  // Fallback handler for broken images
  const handleImageError = (event, project) => {
    const fallback = getMediaSrc(project?.image);
    if (fallback && event.target.src !== fallback) {
      event.target.src = fallback;
    }
  };

  // Animation for card entrance
  const [visibleCards, setVisibleCards] = useState([]);

  useEffect(() => {
    if (projects.length) {
      let timer = setTimeout(() => {
        setVisibleCards(projects.map((_, i) => i));
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [projects]);

  // Preload videos when project is selected
  useEffect(() => {
    if (selectedProject?.gallery) {
      selectedProject.gallery.forEach(media => {
        if (media.includes('.mp4') || media.includes('.MP4')) {
          const video = document.createElement('video');
          video.preload = 'auto';
          video.src = media.startsWith('http') ? media : getMediaSrc(media);
        }
      });
    }
  }, [selectedProject]);

  // Get current media for card - always show first image
  const getCardCurrentMedia = (project) => {
    const media = project.image || (project.gallery && project.gallery[0]);
    return getMediaSrc(media);
  };

  // Check if card media is video
  const isCardMediaVideo = (project) => {
    const media = getCardCurrentMedia(project);
    return media && (media.includes('.mp4') || media.includes('.webm') || media.includes('.ogg'));
  };

  // Scroll functions for horizontal scrolling
  const scrollProjectsLeft = () => {
    if (projectListRef.current) {
      projectListRef.current.scrollBy({ left: -380, behavior: 'smooth' });
    }
  };

  const scrollProjectsRight = () => {
    if (projectListRef.current) {
      projectListRef.current.scrollBy({ left: 380, behavior: 'smooth' });
    }
  };

  return (
    <section className="projects">
      {/* Projects Header */}
      <div className="projects-header">
        <img src="/logo/logo.png" alt="לוגו בינה" className="projects-logo" />
        <h2>הפרוייקטים שלנו</h2>
        <p>הכירו את הפרויקטים המובילים שלנו לשנת 2025 – איכות, חדשנות ותכנון שמוכר!</p>
        <button className="cta-btn" onClick={scrollToContact}>
          התחל פרויקט משלך <FaTools style={{ marginLeft: '8px' }} />
        </button>
      </div>

      {error && (
        <div className="error-message">
          שגיאה: {error}
        </div>
      )}

      {/* Main Project Display */}
      {selectedProject && (
        <div className="project-showcase">
          {/* Main Image/Video Display */}
          <div className="main-media-container">
            {isCurrentMediaYouTube() ? (
              <iframe
                className="main-media youtube-embed"
                src={`https://www.youtube.com/embed/${getYouTubeId()}?rel=0&modestbranding=1&controls=0&autoplay=1&mute=1&playsinline=1`}
                title="YouTube video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ) : isCurrentMediaVideo() ? (
              <video
                className="main-media"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                key={getCurrentMedia()}
              >
                <source src={getMediaSrc(getCurrentMedia())} type="video/mp4" />
                <source src={getMediaSrc(getCurrentMedia())} type="video/webm" />
                <source src={getMediaSrc(getCurrentMedia())} type="video/ogg" />
                הדפדפן שלך לא תומך בסרטונים.
              </video>
            ) : (
              <img
                className="main-media"
                src={getMediaSrc(getCurrentMedia())}
                alt={selectedProject.title}
                onError={(e) => handleImageError(e, selectedProject)}
                key={`main-${selectedProject?.id}-${currentImageIndex}-${getCurrentMedia()}`}
              />
            )}

            {/* Project Info Overlay - Clean Version */}
            <div className="project-info-overlay">
              {getTag(selectedProject) && <span className="tag main-tag">{getTag(selectedProject)}</span>}
              <h3 className="project-title">{selectedProject.title}</h3>
              <button
                className="info-btn"
                onClick={() => {
                  setModalSlideIndex(0);
                  setShowProjectInfoModal(true);
                }}
              >
                מידע נוסף <FaStar style={{ marginLeft: '8px' }} />
              </button>
            </div>
          </div>

          {/* Thumbnail Carousel */}
          {selectedProject.gallery && selectedProject.gallery.length > 1 && (
            <div className="thumbnail-carousel">
              <div className="thumbnail-container">
                {selectedProject.gallery.map((media, index) => {
                  const isYouTube = media.startsWith('youtube:');
                  const youtubeId = isYouTube ? media.replace('youtube:', '') : null;
                  const mediaSrc = isYouTube ? null : getMediaSrc(media);
                  const isVideo = media.includes('.mp4') || media.includes('.webm') || media.includes('.ogg') || media.includes('.MP4');
                  const isBefore = media.includes('/before/') || media.includes('/לפני/') || media.includes('IMG_5995');
                  const isAfter = media.includes('/after/') || media.includes('/אחרי/') || media.includes('IMG_0947') || media.includes('IMG_2826') || media.includes('IMG_2833') || media.includes('IMG_2479') || media.includes('2ba98106');
                  const isProcess = media.includes('/proccess/') || media.includes('IMG_3876') || media.includes('IMG_3957');
                  const isFuture = media.includes('/future/');

                  return (
                    <div
                      key={index}
                      className={`thumbnail ${index === currentImageIndex ? 'active' : ''}`}
                      onClick={() => handleThumbnailClick(index)}
                    >
                      {isYouTube ? (
                        <>
                          <img
                            className="thumbnail-media"
                            src={`https://img.youtube.com/vi/${youtubeId}/mqdefault.jpg`}
                            alt="YouTube video"
                            loading="lazy"
                          />
                          <span className="thumb-badge video-badge"><FaPlay /> יוטיוב</span>
                        </>
                      ) : isVideo ? (
                        <div className="video-thumbnail-placeholder">
                          <FaPlayCircle className="video-play-icon" />
                          {isBefore && <span className="thumb-badge before-badge">לפני</span>}
                          {isAfter && <span className="thumb-badge after-badge">אחרי</span>}
                          {isProcess && <span className="thumb-badge process-badge">תהליך</span>}
                          {isFuture && <span className="thumb-badge future-badge">עתידי</span>}
                          {!isBefore && !isAfter && !isProcess && !isFuture && <span className="thumb-badge video-badge">סרטון</span>}
                        </div>
                      ) : (
                        <>
                          <img
                            className="thumbnail-media"
                            src={mediaSrc}
                            alt={`${selectedProject.title} ${index + 1}`}
                            loading="lazy"
                            onError={(e) => handleImageError(e, selectedProject)}
                          />
                          {isBefore && <span className="thumb-badge before-badge">לפני</span>}
                          {isAfter && <span className="thumb-badge after-badge">אחרי</span>}
                          {isProcess && <span className="thumb-badge process-badge">תהליך</span>}
                          {isFuture && <span className="thumb-badge future-badge">עתידי</span>}
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Button to open Facebook video */}
          {selectedProject.facebookVideo && (
            <button
              className="facebook-video-btn"
              onClick={() => setShowFacebookModal(true)}
            >
              <FaFacebookF style={{ marginLeft: '8px' }} />
              צפה בסרטון פייסבוק
              <FaPlayCircle style={{ marginRight: '8px' }} />
            </button>
          )}

          {/* Modal for Facebook video */}
          {showFacebookModal && (
            <div className="modal-overlay" onClick={() => setShowFacebookModal(false)}>
              <div className="modal-content" onClick={e => e.stopPropagation()}>
                <button className="close-modal" onClick={() => setShowFacebookModal(false)}>×</button>
                <div dangerouslySetInnerHTML={{ __html: selectedProject.facebookVideo }} />
              </div>
            </div>
          )}

          {/* Modal for Project Info */}
          {showProjectInfoModal && (
            <div className="modal-overlay" onClick={() => setShowProjectInfoModal(false)}>
              <div className="modal-content project-info-modal" onClick={e => e.stopPropagation()}>
                <button className="close-modal" onClick={() => setShowProjectInfoModal(false)}>×</button>
                <div className="project-info-content">
                  <div className="modal-header">
                    {getTag(selectedProject) && <span className="tag modal-tag">{getTag(selectedProject)}</span>}
                    <h2>{selectedProject.title}</h2>
                  </div>

                  {/* Image Slider in Modal */}
                  {selectedProject.gallery && selectedProject.gallery.length > 0 && (
                    <div className="modal-slider">
                      <div className="modal-slider-main">
                        {selectedProject.gallery[modalSlideIndex]?.includes('.mp4') ||
                          selectedProject.gallery[modalSlideIndex]?.includes('.webm') ? (
                          <video
                            className="modal-slider-media"
                            autoPlay
                            muted
                            loop
                            playsInline
                            key={modalSlideIndex}
                          >
                            <source src={getMediaSrc(selectedProject.gallery[modalSlideIndex])} type="video/mp4" />
                          </video>
                        ) : (
                          <img
                            className="modal-slider-media"
                            src={getMediaSrc(selectedProject.gallery[modalSlideIndex])}
                            alt={`${selectedProject.title} ${modalSlideIndex + 1}`}
                            onError={(e) => handleImageError(e, selectedProject)}
                            key={modalSlideIndex}
                          />
                        )}

                        {/* Navigation Arrows */}
                        <button
                          className="slider-arrow slider-arrow-right"
                          onClick={() => setModalSlideIndex(prev =>
                            prev === selectedProject.gallery.length - 1 ? 0 : prev + 1
                          )}
                        >
                          <FaChevronRight />
                        </button>
                        <button
                          className="slider-arrow slider-arrow-left"
                          onClick={() => setModalSlideIndex(prev =>
                            prev === 0 ? selectedProject.gallery.length - 1 : prev - 1
                          )}
                        >
                          <FaChevronLeft />
                        </button>

                        {/* Slide Counter */}
                        <div className="slider-counter">
                          {modalSlideIndex + 1} / {selectedProject.gallery.length}
                        </div>
                      </div>

                      {/* Thumbnail Strip */}
                      <div className="modal-slider-thumbs">
                        {selectedProject.gallery.slice(0, 8).map((media, idx) => (
                          <div
                            key={idx}
                            className={`modal-thumb ${idx === modalSlideIndex ? 'active' : ''}`}
                            onClick={() => setModalSlideIndex(idx)}
                          >
                            {media.includes('.mp4') || media.includes('.webm') ? (
                              <video className="modal-thumb-media" muted>
                                <source src={getMediaSrc(media)} type="video/mp4" />
                              </video>
                            ) : (
                              <img
                                className="modal-thumb-media"
                                src={getMediaSrc(media)}
                                alt=""
                                onError={(e) => handleImageError(e, selectedProject)}
                              />
                            )}
                          </div>
                        ))}
                        {selectedProject.gallery.length > 8 && (
                          <div className="modal-thumb more-indicator">
                            +{selectedProject.gallery.length - 8}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="modal-body">
                    <p className="project-full-description">{selectedProject.desc}</p>
                  </div>
                  <div className="modal-footer">
                    {/* WhatsApp CTA Button - Primary */}
                    <a
                      href={`https://wa.me/972522714455?text=${encodeURIComponent(`היי, ראיתי את הפרויקט "${selectedProject.title}" באתר ואשמח לשמוע על פרויקט דומה.`)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="whatsapp-cta-btn"
                    >
                      <FaWhatsapp style={{ marginLeft: '10px', fontSize: '1.3em' }} />
                      דברו איתי על פרויקט דומה
                    </a>

                    <button
                      className="cta-btn modal-cta secondary-cta"
                      onClick={() => {
                        setShowProjectInfoModal(false);
                        setTimeout(() => scrollToContact(), 300);
                      }}
                    >
                      <FaTools style={{ marginLeft: '8px' }} />
                      או השאירו פרטים ונחזור אליכם
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Project List */}
      <div className="projects-container">
        <button
          className="projects-scroll-indicator left"
          onClick={scrollProjectsLeft}
          aria-label="גלול שמאלה"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>

        <div className="project-list" ref={projectListRef}>
          {projects.map((project, idx) => (
            <div
              key={project.id}
              className={`project-card ${selectedProject && selectedProject.id === project.id ? 'selected' : ''}`}
              style={{
                opacity: visibleCards.includes(idx) ? 1 : 0,
                transition: 'opacity 0.8s'
              }}
              onClick={() => handleProjectSelect(project)}
            >
              {getTag(project) && <span className="tag">{getTag(project)}</span>}

              {/* Card Media Container */}
              <div className="card-media-container">
                {isCardMediaVideo(project) ? (
                  <video
                    className="card-media"
                    autoPlay
                    muted
                    loop
                    playsInline
                    key={getCardCurrentMedia(project)} // Force re-render on change
                  >
                    <source src={getCardCurrentMedia(project)} type="video/mp4" />
                    <source src={getCardCurrentMedia(project)} type="video/webm" />
                    <source src={getCardCurrentMedia(project)} type="video/ogg" />
                    <img src={project.image} alt={project.title} className="card-media-fallback" />
                  </video>
                ) : (
                  <img
                    className="card-media"
                    src={getCardCurrentMedia(project)}
                    alt={project.title}
                    onError={(e) => handleImageError(e, project)}
                  />
                )}

                {/* Gallery indicator - shows number of images */}
                {(project.gallery && project.gallery.length > 1) && (
                  <div className="gallery-count">
                    <span>{project.gallery.length} תמונות</span>
                  </div>
                )}
              </div>

              <h3>{project.title}</h3>
              <p>{project.desc}</p>
            </div>
          ))}
        </div>

        <button
          className="projects-scroll-indicator right"
          onClick={scrollProjectsRight}
          aria-label="גלול ימינה"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>
      </div>
    </section>
  );
}

export default Projects;
